import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styles: ['']
})
export class PagesComponent implements OnInit {

  constructor() {
    document.getElementById('body')?.addEventListener('click', eve => this.onClick(eve));
  }

  ngOnInit() {
  }

  onClick(event) {
    const target = event.target || event.srcElement || event.currentTarget;
    const collapse = document.getElementById('collapseNotification');
    if (!collapse?.contains(target)) {
      if (collapse?.getAttribute('class').search('show') > 0) {
        document.getElementById('bell').click();
      }
    }
  }

}
